<template>
  <button v-if="visible" class="voucher-btn" @click="handleClick">
    <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i>
    <span>View Voucher</span>
  </button>
</template>

<script>
import { openVoucher } from "../../modules/navigation/modals/vouchers-documents/service";
import { mapGetters } from "vuex";
export default {
  props: {
    type: {
      type: String,
      required: false,
    },
    vouchno: {
      type: String,
      required: false,
    },
  },
  data() {
    return { visible: true };
  },
  computed: {
    ...mapGetters({
      sessionNum: "booking/getSessionID",
      bookingName: "booking/getBookingSurname",
      bookingNumber: "booking/getBookingNumber",
    }),
  },
  methods: {
    showError(variant = null, _text) {
      this.$bvToast.toast(_text, {
        title: `Error Getting PDF`,
        variant: variant,
        solid: true
      })
    },
    openVoucher(flag, vouchno, index) {
      let extension = "";
      const _bookingSite = this.bookingNumber.charAt(0).toUpperCase() === 'R' ? 'ie' : 'com';
      if (flag === "supplier") {
        extension = this.essInfo.supplier_documents.filenames[index].replace(
          " ",
          "%20"
        );
      }
      setTimeout(() => {
      if (flag === "bedsonline") {
          const param = vouchno.replace(/^BEDSONLINE-/, "");
          window.open(
            `https://www.trailfinders.${_bookingSite}/tourdoc/bedsonline/${param}.pdf`,
            "_blank"
          );
        } else if (flag === "viator") {
          const param = vouchno.replace(/^VIATOR-/, "");
          window.open(
            `https://www.trailfinders.${_bookingSite}/tourdoc/viator/${param}.pdf`,
            "_blank"
          );
        } else {
          window.open(
            `https://www.trailfinders.${_bookingSite}/tourdoc/bybookno/${this.booking.user_information.bookingNumber}/${extension}`,
            "_blank"
          );
        }
      }, 500);
    },
    async handleClick() {
      if(this.type ==='viator'){
        this.openVoucher('viator', this.vouchno, 0);
      } else if(this.type ==='bedsonline'){
        this.openVoucher('bedsonline', this.vouchno, 0);
      } else if(this.type ==='supplier'){
        this.$emit('open-voucher')
      } else {
        this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
        const system = this.bookingNumber.charAt(0).toUpperCase() === 'R' ? 'IE' : 'UK';
        const vouch = await openVoucher(this.bookingName, this.bookingNumber, this.vouchno, system, this.sessionNum);
        this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });
        if (vouch.error) {
          this.showError('danger', 'Error loading PDF.')
        }
      }
    },
  },
};
</script>
